import { useState, useEffect, useCallback } from "react";
import { Chip, TableCell } from "@mui/material";
import "../../Styles/style.css";
import "./Ticket.css";
import AdminApiModule from "../../components/AdminApi/Api/api";
import { Button } from "@mui/material";
import TicketEditPincodePopup from "../../components/AdminApi/ticketEditPincodePopup";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import BasicDateRangePicker from "../../components/common/datepicker";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
import CloseTicketRemarksModal from "../../components/Components/CloseTicketRemark";
import AssignTechnicianPopup from "../../components/AdminApi/Api/assignTechnicianPopup";
import RemarksPopup from "../../components/AdminApi/Api/RemarksPopup";
import DeleteAlertDialogModal from "../../components/Components/DeleteAlert";
import UpdateIcon from "@mui/icons-material/Update";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/styles";
import FileUploadErrors from "../../components/FileUploadErrors";
import axios from "axios";
import { BASE_URL } from "../../components/config/config";
import InputBase from "@mui/material/InputBase";
import { withStyles } from "@mui/styles";
import RebookModal from "../../components/Components/RebookMoadl";
import CancelIcon from "@mui/icons-material/Cancel";
import MUIDataTable from "mui-datatables";
import {
  canViewTickets,
  canViewAllTickets,
  canViewNormalTickets,
  canUpdateTicket,
  canDeleteTicket,
  canAssignUnassignTicket,
  canBroadcastTicket,
  canViewClosedTickets,
  canRemarkTicket,
  canViewContactNumber,
  canCloseTicket,
  hasFullAccess,
} from "../../utility/permissionUtils";

const CustomFilter = withStyles({
  filter: {
    background: "red",
  },
})(InputBase);

const Input = styled("input")({
  display: "none",
});

const stylesCss = {
  inputBox: {
    width: "100%",
    marginBottom: "10px",
  },
  gridStyle: {
    width: "80%",
    margin: "auto",
  },
  paddingInnerGrids: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "10px",
  },
};

const options = {
  filterType: "dropdown",
  filter: true,
  download: false,
  downloadOptions: {
    filterOptions: {
      useDisplayedRowsOnly: true,
      useDisplayedColumnsOnly: true,
    },
  },
  customFilterMenuRender: (filterValue, onFilterUpdate, column) => {
    return (
      <CustomFilter
        value={filterValue || ""}
        onChange={(event) => onFilterUpdate(event.target.value)}
        placeholder={`Filter ${column.label}`}
      />
    );
  },
  downloadProps: {
    filterOptions: {
      useDisplayedRowsOnly: true,
      useDisplayedColumnsOnly: true,
    },
  },
};

const PendingTickets = ({ reduxState }) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    ticketsList: [],
    ticketObj: [],
    centerlist: [],
    isConfirmationModalOpen: false,
    ticketToBroadcast: null,
    isEditOpenAddressPincode: false,
    isEditOpenTicketDetails: {},
    isPincodeUpdating: false,
    getSingleTicketData: [],
    isLoading: false,
    selectedTicketIds: [],
    isAllRowsSelected: false,
    doesFileUploadErrorExists: false,
    errorsList: {},
    selectedRowsClosingPrice: {},
    totalClosingPrice: 0,
    isApiButtonVisible: false,
    isAssignTechnicianPopupOpen: false,
    isRemarksPopupOpen: false,
    isDeleteAlertPopupOpen: false,
    deleteHeading: "Ticket",
    ticketDetailsForAssignTechnician: {},
    isTechnicianAssigning: false,
    technicianList: [],
    isCloseTicketRemarksModalOpen: false,
    closingTicketId: "",
    deleteTicketId: "",
    rebookTicketId: "",
    centerAssignId: "",
    isForChange: false,
    openRebook: false,
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    selectedTicketId: null,
    username: "",
    initialRemarks: "",
    processedname: "",
  });

  // Get user permissions from redux state
  const userPermissions = reduxState?.adminDetails?.role_id?.permissions || {};

  // Check permissions
  const hasViewAccess = canViewTickets(userPermissions);
  const hasViewAllTicketsAccess = canViewAllTickets(userPermissions);
  const hasViewNormalTicketsAccess = canViewNormalTickets(userPermissions);
  const hasUpdateAccess = canUpdateTicket(userPermissions);
  const hasDeleteAccess = canDeleteTicket(userPermissions);
  const hasAssignUnassignAccess = canAssignUnassignTicket(userPermissions);
  const hasBroadcastAccess = canBroadcastTicket(userPermissions);
  const hasCloseTicketAccess = canCloseTicket(userPermissions);
  const hasRemarkAccess = canRemarkTicket(userPermissions);
  const hasViewContactNumberAccess = canViewContactNumber(userPermissions);
  const hasFullTicketAccess = hasFullAccess(userPermissions);

  // Check if user has any view access to tickets
  const hasAnyTicketViewAccess =
    hasViewAccess ||
    hasViewAllTicketsAccess ||
    hasViewNormalTicketsAccess ||
    hasFullTicketAccess;

  const columns = [
    {
      name: "Created_at",
      label: "Created on",
      options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Created On
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "assignedAt",
      label: "Assigned on",
      Options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Assigned On
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "daysDifference",
      label: <b>Aging</b>,
      options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Aging
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "ticket_id",
      label: "Ticket Id",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Id
          </TableCell>
        ),
      },
    },
    {
      name: "tstatus",
      label: "Ticket status",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Status
          </TableCell>
        ),
        customBodyRender: (value) => {
          return value == "Technician Assigned" ? (
            <Chip label={value} style={{ background: "#8FD1AD" }} />
          ) : (
            <Chip
              label={value}
              style={{
                background:
                  value == "PENDING"
                    ? "#FF9933"
                    : value == "Technician Not Assigned"
                    ? "#E76161"
                    : value == "VERIFIED"
                    ? "#00CC00"
                    : value == "CLOSED"
                    ? "#FF9999"
                    : "red",
              }}
            />
          );
        },
      },
    },
    {
      name: "bstatus",
      label: "Broadcast status",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Broadcast status
          </TableCell>
        ),
      },
    },
    {
      name: "paidbypublic",
      label: "Paid By Public",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Paid By Public
          </TableCell>
        ),
      },
    },
    {
      name: "paidbytechnician",
      label: "Paid By technician",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Paid By Technician
          </TableCell>
        ),
      },
    },
    {
      name: "technician_id",
      label: "Assigned technician",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Assigned technician
          </TableCell>
        ),
      },
    },
    {
      name: "specific_requirements",
      label: "Specific Requirements",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Specific Requirements
          </TableCell>
        ),
      },
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        filter: false,
        sort: false,
        display: !hasViewContactNumberAccess ? "none" : "true",
        customHeadRender: () => (
          <TableCell
            style={{
              fontSize: "17px",
              fontWeight: "600",
              width: hasViewContactNumberAccess ? "auto" : "0",
              padding: hasViewContactNumberAccess ? "normal" : "0",
              display: hasViewContactNumberAccess ? "table-cell" : "none",
            }}
            align="center"
          >
            Phone
          </TableCell>
        ),
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Name
          </TableCell>
        ),
      },
    },
    {
      name: "tcreatedby",
      label: "Ticket Created By",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Created By
          </TableCell>
        ),
      },
    },
    {
      name: "Center_QR",
      label: "Center QR Id ",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Center_QR
          </TableCell>
        ),
      },
    },
    {
      name: "timeprefrence",
      label: "Ticket Created By",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Timeprefrence
          </TableCell>
        ),
      },
    },
    {
      name: "action",
      label: "Actions",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", width: "900px" }}>
              <Button
                sx={{
                  fontSize: "12px !important",
                  marginRight: "15px !important",
                }}
                variant="contained"
                onClick={() => handleViewTicket(value?._id)}
              >
                View Request
              </Button>

              {hasUpdateAccess && (
                <Button
                  sx={{
                    fontSize: "12px !important",
                    marginRight: "15px !important",
                  }}
                  variant="contained"
                  onClick={() => handleEditTicket(value?._id)}
                >
                  Edit Request
                </Button>
              )}

              {hasCloseTicketAccess &&
                value?.is_technician_assigned &&
                value?.ticket_status !== "CLOSED" && (
                  <Button
                    sx={{
                      fontSize: "10px !important",
                      marginRight: "15px !important",
                    }}
                    onClick={() =>
                      clickCloseTicket(
                        value?._id,
                        value?.assigned_ids?.assigned_center_id?._id,
                        value?.ticket_id
                      )
                    }
                    variant="contained"
                    color="primary"
                    disabled={
                      !value?.service_available ||
                      !value?.assigned_ids?.assigned_center_id?._id
                    }
                  >
                    Close Request
                  </Button>
                )}

              {hasBroadcastAccess && !value?.is_technician_assigned && (
                <Button
                  sx={{
                    fontSize: "10px !important",
                    marginRight: "15px !important",
                  }}
                  variant="contained"
                  onClick={() => {
                    handleOpenConfirmationModal(value?._id);
                  }}
                >
                  Broadcast
                </Button>
              )}

              {hasUpdateAccess && value?.ticket_status == "CLOSED" && (
                <Tooltip title="Rebook">
                  <Button
                    style={{
                      background: "#FCE9F1",
                      marginLeft: "10px",
                    }}
                    onClick={() => handleRebookOpen(value?._id)}
                  >
                    <UpdateIcon style={{ color: "green" }} />
                  </Button>
                </Tooltip>
              )}

              {hasRemarkAccess && (
                <Button
                  sx={{
                    fontSize: "12px !important",
                    marginLeft: "10px !important",
                    marginRight: "15px !important",
                    backgroundColor: value?.remarks?.onboarding_team_remarks
                      ? "green !important"
                      : "FCE9F1 !important",
                  }}
                  onClick={() =>
                    handleRemarks(
                      value?._id,
                      reduxState.adminDetails.user_name,
                      value?.remarks?.onboarding_team_remarks,
                      value?.remarks?.onboarding_team_name
                    )
                  }
                  variant="contained"
                >
                  Remarks
                </Button>
              )}

              {hasDeleteAccess && (
                <Button
                  sx={{
                    fontSize: "12px !important",
                    marginLeft: "10px !important",
                    backgroundColor: "#f44336",
                    color: "white",
                  }}
                  onClick={() => clickDeleteTicket(value?._id)}
                  variant="contained"
                >
                  Delete
                </Button>
              )}
            </div>
          );
        },
      },
    },
  ];

  const updateState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  const handleRemarks = (ticketId, username, initialRemarks, processedname) => {
    if (!hasRemarkAccess) return;

    updateState({
      isRemarksPopupOpen: true,
      selectedTicketId: ticketId,
      username: username,
      initialRemarks: initialRemarks,
      processedname: processedname,
    });
  };

  const handleCloseRemarksPopup = () => {
    updateState({
      isRemarksPopupOpen: false,
      selectedTicketId: null,
    });
  };

  const handleSaveRemarks = (ticketId, remarks, username) => {
    if (!hasRemarkAccess) return;

    console.log("Ticket ID:", ticketId);
    console.log("Remarks:", remarks);
    console.log("Username:", username);
    handleCloseRemarksPopup();
  };

  const handleOpenConfirmationModal = (ticketId) => {
    if (!hasBroadcastAccess) return;

    updateState({
      isConfirmationModalOpen: true,
      ticketToBroadcast: ticketId,
    });
  };

  const handleCloseConfirmationModal = () => {
    updateState({ isConfirmationModalOpen: false, ticketToBroadcast: null });
  };

  const handleBroadcastConfirm = () => {
    if (!hasBroadcastAccess) return;

    const { ticketToBroadcast } = state;
    const apiUrl = `${BASE_URL}technicianApp/ticket-broadcast`;

    const requestData = {
      ticket_obj_id: ticketToBroadcast,
    };

    updateState({ isLoading: true });

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        console.log("Ticket broadcasted successfully");
        handleCloseConfirmationModal();
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      })
      .finally(() => {
        updateState({ isLoading: false });
      });
  };

  const handleEditTicket = (id) => {
    if (!hasUpdateAccess) return;
    navigate("/admin-ticket?edit=" + id);
  };

  const handleViewTicket = (id) => {
    if (!hasAnyTicketViewAccess) return;
    window.open(`/#/view-ticket?ticketId=${id}`, '_blank');
  };

  const handleViewwTicket = (images, id) => {
    if (!hasAnyTicketViewAccess) return;
    navigate("/ticketDocument", {
      state: { imageUrls: images, ticketId: id },
    });
  };

  const fetchMultipleImages = (data) => {
    if (!hasAnyTicketViewAccess) return;
    const allImages = data.reduce((images, item) => {
      return images.concat(item.onsite_pictures || []);
    }, []);

    navigate("/ticketDocument", {
      state: { imageUrls: allImages },
    });
  };

  const clickCloseTicket = (ticket_obj_id, centerAssignId, ticketId) => {
    if (!hasCloseTicketAccess) return;

    const ticket_Id = localStorage.getItem("tickeClose_Id");
    const payload = {
      ticket_obj_id: ticket_obj_id,
    };

    if (ticket_Id) {
      new AdminApiModule().getSingleTicket(payload).then((res) => {
        updateState({ getSingleTicketData: res?.data });
      });
    }

    updateState({
      closingTicketId: ticket_obj_id,
      centerAssignId: centerAssignId,
    });
    handleOpenCloseTicketRemarksModal(ticket_obj_id, centerAssignId);
    localStorage.setItem("tickeClosetId", ticketId);
    localStorage.setItem("tickeClose_Id", ticket_obj_id);
  };

  const clickDeleteTicket = (ticketId) => {
    if (!hasDeleteAccess) return;

    updateState({ deleteTicketId: ticketId });
    handleOpenCloseTicketDeleteModal(ticketId);
    localStorage.setItem("ticketId", ticketId);
  };

  const sameINA = (ticketDetails, callback) => {
    const payload = {
      ticket_obj_id: ticketDetails._id,
    };

    const apiUrl = `${BASE_URL}admin/get-center-for-ticket`;

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        console.log("Response data:", res.data);
        callback(res.data);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleOpenTechnicianPopup = (
    ticketDetails,
    isForChangeValue,
    centerlist
  ) => {
    if (!hasAssignUnassignAccess) return;

    updateState({
      isAssignTechnicianPopupOpen: true,
      ticketDetailsForAssignTechnician: ticketDetails,
      isForChange: isForChangeValue,
      centerlist: centerlist,
    });
  };

  const handleCloseAssignTechnicianPopup = () => {
    updateState({
      isAssignTechnicianPopupOpen: false,
      ticketDetailsForAssignTechnician: {},
    });
  };

  const handleOpenCloseTicketRemarksModal = () => {
    if (!hasCloseTicketAccess) return;

    updateState({
      isCloseTicketRemarksModalOpen: true,
    });
  };

  const handleOpenCloseTicketDeleteModal = () => {
    if (!hasDeleteAccess) return;

    updateState({
      isDeleteAlertPopupOpen: true,
    });
  };

  const onClickFilter = (value) => {
    if (!hasAnyTicketViewAccess) return;

    startLoading();

    let payload = {
      start_date: value[0],
      end_date: value[1],
    };
    new AdminApiModule()
      .getAllPendingTickets(payload)
      .then((res) => {
        let parsedData = [];
        if (res?.data?.length) {
          parsedData = getParsedData(res.data);
        }
        updateState({
          ticketsList: parsedData,
        });

        stopLoading();
      })
      .catch((err) => {
        stopLoading();
        console.log(err);
      });
  };

  const refreshData = () => {
    if (!hasAnyTicketViewAccess) return;

    startLoading();

    new AdminApiModule()
      .getAllPendingTickets()
      .then((res) => {
        let parsedData = [];
        if (res?.data?.length) {
          parsedData = getParsedData(res.data);
        }
        updateState({
          ticketsList: parsedData,
        });

        stopLoading();
      })
      .catch((err) => {
        stopLoading();
        console.log(err);
      });
  };

  const startLoading = () => {
    updateState({ isLoading: true });
  };

  const stopLoading = () => {
    updateState({ isLoading: false });
  };

  const handleBroadCastTicket = (value) => {
    if (!hasBroadcastAccess) return;

    let payload = {
      ticket_obj_id: value?._id,
    };
    new AdminApiModule()
      .adminBroadCast(payload)
      .then((res) => {
        getAllPendingTickets();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCloseTicket = (
    closingTicketRemarks,
    closingPrice,
    closingCode,
    reasonToClose
  ) => {
    if (!hasCloseTicketAccess) return;

    if (!(closingPrice == 0 || closingPrice)) {
      return;
    }

    if (state.closingTicketId && state.closingTicketId.length > 0) {
      let payload = {
        center_id: state.centerAssignId,
        ticket_obj_id: state.closingTicketId,
        remarks: {
          close_ticket_remarks: reasonToClose,
          technician_remarks: closingTicketRemarks,
        },
        amount: parseInt(closingPrice),
        code: closingCode,
      };

      new AdminApiModule()
        .closeTicket(payload)
        .then((res) => {
          updateState({ closingTicketId: "" });
          handleCloseCloseTicketRemarksModal();
          showDialog(true, "success", "Ticket closed successfully");
          getAllPendingTickets();
        })
        .catch((err) => {
          console.log(err);
          showDialog(true, "error", err?.response?.data?.message);
        });
    }
  };

  const handleRevisitCloseTicket = (
    closingTicketRemarks,
    closingPrice,
    closingCode,
    reasonToClose,
    revisitRemark
  ) => {
    if (!hasCloseTicketAccess) return;

    if (!(closingPrice == 0 || closingPrice)) {
      return;
    }

    if (state.closingTicketId && state.closingTicketId.length > 0) {
      let payload = {
        center_id: state.centerAssignId,
        ticket_obj_id: state.closingTicketId,
        remarks: {
          close_ticket_remarks: reasonToClose,
          technician_remarks: closingTicketRemarks,
          revisit_remarks: revisitRemark,
        },
        amount: parseInt(closingPrice),
        code: closingCode,
      };

      new AdminApiModule()
        .closeTicket(payload)
        .then((res) => {
          updateState({ closingTicketId: "" });
          handleCloseCloseTicketRemarksModal();
          showDialog(true, "success", "Ticket closed successfully");
          getAllPendingTickets();
        })
        .catch((err) => {
          console.log(err);
          showDialog(true, "error", err?.response?.data?.message);
        });
    }
  };

  const handleAssignTechnician = (technician_obj_id) => {
    if (!hasAssignUnassignAccess) return;

    if (!technician_obj_id) {
      return;
    }
    updateState({ isTechnicianAssigning: true });
    let payload = {
      ticket_obj_id: state.ticketDetailsForAssignTechnician._id,
      technician_obj_id: technician_obj_id,
    };

    new AdminApiModule()
      .assignTechnician(payload)
      .then((res) => {
        handleCloseAssignTechnicianPopup();
        updateState({ isTechnicianAssigning: false });
        getAllPendingTickets();
      })
      .catch((err) => {
        updateState({ isTechnicianAssigning: false });
        console.log(err);
      });
  };

  const handleChangeTechnician = (technician_obj_id) => {
    if (!hasAssignUnassignAccess) return;

    if (!technician_obj_id) {
      return;
    }

    updateState({ isTechnicianAssigning: true });
    let payload = {
      ticket_obj_id: state.ticketDetailsForAssignTechnician._id,
      technician_obj_id: technician_obj_id,
    };

    new AdminApiModule()
      .changeTechnician(payload)
      .then((res) => {
        handleCloseAssignTechnicianPopup();
        updateState({ isTechnicianAssigning: false });
        getAllPendingTickets();
      })
      .catch((err) => {
        updateState({ isTechnicianAssigning: false });
        console.log(err);
      });
  };

  const getAllTechnician = useCallback(() => {
    if (!hasAssignUnassignAccess) return;

    new AdminApiModule()
      .getAllTechnician()
      .then((res) => {
        updateState({
          technicianList: res?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [hasAssignUnassignAccess]);

  const handleOpenEditPincodePopup = (value) => {
    if (!hasUpdateAccess) return;

    updateState({
      isEditOpenAddressPincode: true,
      isEditOpenTicketDetails: value,
    });
  };

  const handleApiCall = () => {
    updateState({ selectedTicketIds: [] });
  };

  const handleCloseEditPincodePopup = () => {
    updateState({
      isEditOpenAddressPincode: false,
      isEditOpenTicketDetails: {},
    });
  };

  const getFormattedAddress = (addressObject) => {
    let addressLine =
      addressObject?.house_number +
      ", " +
      addressObject?.locality +
      ", " +
      addressObject?.city +
      ", " +
      addressObject?.state;
    return addressLine;
  };

  const getParsedData = (data) => {
    let parsedData = data?.map((item) => {
      let closingPrice = item?.closing_ticket_price;
      if (closingPrice === "-" || closingPrice === undefined) {
        closingPrice = 0;
      } else {
        closingPrice = parseFloat(closingPrice);
      }

      return {
        Created_at: new Date(item?.createdAt).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        }),
        assignedAt: item?.assignedAt
          ? new Date(item?.assignedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })
          : "-",
        closeddate: item?.closedAt
          ? new Date(item?.closedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })
          : "-",
        updatedAt: item?.updatedAt
          ? new Date(item?.updatedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })
          : "-",
        daysDifference: moment().diff(moment(item?.createdAt), "days"),
        Image: item?.onsite_pictures,
        ticket_id: item?.ticket_id || "-",
        Qr_Id: item?.assigned_ids?.assigned_center_id?.qr_details?.qr_id || "-",
        offer_code: item?.offers_applied?.offer_code || "-",
        center_id: item?.assigned_ids?.assigned_center_id?.center_name,
        technician_id:
          item?.assigned_ids?.assigned_technician_id?.personal_details?.name,
        service_required: `${item?.service_provided_for?.service_name.slice(
          0,
          30
        )}...`,
        name: item.personal_details.name,
        phone: hasViewContactNumberAccess
          ? item.personal_details.primary_phone.mobile_number
          : "****",
        address: `${getFormattedAddress(item?.address_details).slice(
          0,
          30
        )}...`,
        pincode: item.address_details.pincode,
        createdAt: new Date(item?.createdAt).toLocaleDateString("en-us", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }),
        paidbypublic: item?.is_paid_by_public ? "99" : "0",
        client_id: item?.client_id || "-",
        client_name: item?.client_name || "-",
        specific_requirements: item?.specific_requirement
          ? item?.specific_requirement
          : "-",
        bstatus:
          item?.service_available == false
            ? "No Service Available In This Area "
            : item?.broadcast_status == "broadcasted" &&
              item?.ticket_created_by == "CENTER"
            ? "NEW NOT PAID"
            : item?.broadcast_status == "broadcasted" &&
              item?.ticket_created_by == "PUBLIC_WITH_DELAR_QR"
            ? "DEALER"
            : item?.ticket_created_by == "SUPER_ADMIN" &&
              item?.broadcast_status == "accepted after broadcast"
            ? "Admin Created-Accepted"
            : item?.broadcast_status == "accepted after broadcast"
            ? "Public Created-Accepted"
            : item?.broadcast_status == undefined
            ? "Not Paid (Payment Failed)"
            : item?.broadcast_status == "broadcasted"
            ? `NEW ${
                (item?.is_paid_by_public == true && "99") ||
                (item?.is_paid_by_public == false &&
                  item?.ticket_created_by === "PUBLIC_WITH_CENTER_QR" &&
                  "NOT PAID")
              }`
            : `${item?.broadcast_status} FREE` ||
              (item?.broadcast_status === undefined && "-"),
        tstatus:
          item?.ticket_status == "PENDING" &&
          item?.broadcast_status == "matched_in_same_center" &&
          item?.assigned_ids?.assigned_technician_id?.personal_details?.name
            ? "Technician Assigned"
            : item?.ticket_status == "PENDING" &&
              item?.broadcast_status == "matched_in_same_center" &&
              !item?.assigned_ids?.assigned_technician_id?.personal_details
                ?.name
            ? "Technician Not Assigned"
            : item?.ticket_status == "ACCEPTED" &&
              item?.assigned_ids?.assigned_technician_id?.personal_details?.name
            ? "Technician Assigned"
            : item?.ticket_status == "ACCEPTED" &&
              !item?.assigned_ids?.assigned_technician_id?.personal_details
                ?.name
            ? "Technician Not Assigned"
            : item?.ticket_status,
        tcreatedby: item?.ticket_created_by,
        Rating: item?.remarks?.over_all_rating,
        action: item,
        closingPrice: closingPrice,
        timeprefrence: item?.time_preference?.specific_date_time
          ? new Date(item.time_preference.specific_date_time).toLocaleString(
              "en-IN",
              {
                timeZone: "Asia/Kolkata",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
              }
            )
          : item?.time_preference?.time_preference_type,
        paidbytechnician: item?.is_paid_by_technician ? "99" : "0",
        Center_QR: item?.created_by?.qr_details?.qr_id,
      };
    });

    return parsedData;
  };

  const getAllPendingTickets = useCallback(() => {
    if (!hasAnyTicketViewAccess) return;

    startLoading();

    new AdminApiModule()
      .getAllPendingTickets()
      .then((res) => {
        let parsedData = [];
        if (res?.data?.length) {
          parsedData = getParsedData(res.data);
        }
        updateState({
          ticketsList: parsedData,
        });

        stopLoading();
      })
      .catch((err) => {
        stopLoading();
        console.log(err);
      });
  }, [hasAnyTicketViewAccess]);

  const handleUpdatePincode = (newPincode) => {
    if (!hasUpdateAccess) return;

    if (!newPincode) {
      return;
    }
    let payload = {
      address_details: {
        pincode: newPincode,
      },
      ticket_obj_id: state.isEditOpenTicketDetails?._id,
    };

    updateState({ isPincodeUpdating: true });
    new AdminApiModule()
      .updatePincode(payload)
      .then((res) => {
        updateState({ isPincodeUpdating: false });
        getAllPendingTickets();
        handleCloseEditPincodePopup();
      })
      .catch((err) => {
        updateState({ isPincodeUpdating: false });
      });
  };

  const onUploadCsvFile = (event, stateValue) => {
    if (!hasUpdateAccess) return;

    let files = event.target.files;
    let fileOriginalName = files[0]?.name?.split(".")[0];

    const formData = new FormData();
    formData.append("ticketsCsvFile", files[0], fileOriginalName);

    new AdminApiModule()
      .uploadTicketsCsv(formData)
      .then((res) => {
        console.log("res is", res);
        if (res && res.data && res.data.doesErrorExists) {
          updateState({
            doesFileUploadErrorExists: true,
            errorsList: res.data.errorRowWise,
          });
        } else {
          getAllPendingTickets();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateSelectedRowsClosingPrice = () => {
    const { ticketsList, selectedTicketIds } = state;
    let totalClosingPrice = 0;
    const selectedRowsClosingPrice = {};

    selectedTicketIds.forEach((ticketId) => {
      const rowData = ticketsList.find((row) => row.ticket_id === ticketId);
      if (rowData && rowData.closingPrice) {
        const closingPrice = parseFloat(rowData.closingPrice);
        if (!isNaN(closingPrice)) {
          totalClosingPrice += closingPrice;
          selectedRowsClosingPrice[ticketId] = closingPrice;
        }
      }
    });

    console.log("Selected Rows Closing Price:", selectedRowsClosingPrice);
    console.log("Total Closing Price:", totalClosingPrice);

    updateState({
      selectedRowsClosingPrice,
      totalClosingPrice,
    });
  };

  const handleCloseFileUploadErrors = () => {
    updateState({ doesFileUploadErrorExists: false, errorsList: {} });
  };

  const handleCloseCloseTicketRemarksModal = () => {
    updateState({
      isCloseTicketRemarksModalOpen: false,
    });
  };

  const handleDeleteCloseModal = () => {
    updateState({
      isDeleteAlertPopupOpen: false,
    });
  };

  const handleDeleteRows = async () => {
    if (!hasDeleteAccess) return;

    let accessToken = localStorage.getItem("access_token");
    let ticket_id = localStorage.getItem("ticketId");
    try {
      await axios.delete(`${BASE_URL}admin/deleteTickets/${ticket_id}`, {
        headers: {
          "x-access-token": accessToken,
        },
      });
      handleDeleteCloseModal();
      getAllPendingTickets();
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = async (event, page) => {
    if (!hasAnyTicketViewAccess) return;

    updateState({ currentPage: page });
    let showNo = state.pageSize;
    let currentsPage = state.currentPage;
    let total = 5 + state.currentPage;
    await getAllPendingTickets(total, currentsPage);
  };

  const handleDeleteSelectedRows = () => {
    if (!hasDeleteAccess) return;

    const { selectedTicketIds } = state;
    selectedTicketIds.forEach((ticketId) => {
      clickDeleteTicket(ticketId);
    });

    updateState({ selectedTicketIds: [] });
  };

  const handleRebookOpen = (rebookTicketId) => {
    if (!hasUpdateAccess) return;

    updateState({ rebookTicketId, openRebook: true });
  };

  const handleRebookClose = () => {
    updateState({ openRebook: false });
  };

  const showDialog = (open, type, message) => {
    // Implement your dialog logic here
    console.log(open, type, message);
  };

  useEffect(() => {
    if (hasAnyTicketViewAccess) {
      getAllPendingTickets();
    }
    if (hasAssignUnassignAccess) {
      getAllTechnician();
    }
  }, [
    getAllPendingTickets,
    getAllTechnician,
    hasAnyTicketViewAccess,
    hasAssignUnassignAccess,
  ]);

  const ConfirmationModal = ({
    isOpen,
    handleClose,
    handleConfirm,
    message,
  }) => (
    <div
      className={`modal ${isOpen ? "show" : ""}`}
      style={{
        display: isOpen ? "block" : "none",
        position: "fixed",
        zIndex: 9999,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        className="modal-dialog"
        style={{
          backgroundColor: "black",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: "500px",
          width: "100%",
          height: "200px",
          overflowY: "auto",
          borderRadius: "10px",
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirmation</h5>
            <Button
              type="button"
              className="btn-close"
              onClick={handleClose}
              style={{
                color: "white",
                border: "none",
                background: "black",
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
            >
              <CancelIcon></CancelIcon>
            </Button>
          </div>
          <div className="modal-body" style={{ textAlign: "center" }}>
            <p
              style={{
                color: "white",
                fontWeight: "bold",
                marginTop: "20px",
                marginBottom: "20px",
                borderBottom: "1px solid white",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              {message}
            </p>
          </div>
          <div className="modal-footer" style={{ textAlign: "center" }}>
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              style={{
                backgroundColor: "blue",
                margin: "0 10px",
                color: "white",
                width: "100px",
              }}
            >
              No
            </Button>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={handleConfirm}
              style={{
                backgroundColor: "blue",
                margin: "0 10px",
                color: "white",
                width: "100px",
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  // If user has no permission to view tickets at all
  if (!hasAnyTicketViewAccess) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        No permission to view pending tickets. Please contact administrator.
      </div>
    );
  }

  return (
    <div>
      <RebookModal
        isOpen={state.openRebook}
        handleRebookOpen={handleRebookOpen}
        handleRebookClose={handleRebookClose}
        Ticket_id={state.rebookTicketId}
      />

      {state.isCloseTicketRemarksModalOpen && (
        <CloseTicketRemarksModal
          open={state.isCloseTicketRemarksModalOpen}
          handleClose={handleCloseCloseTicketRemarksModal}
          handleCloseTicket={handleCloseTicket}
          handleRevisitCloseTicket={handleRevisitCloseTicket}
          getSingleTicketData={state.getSingleTicketData?.results}
        />
      )}

      {state.isEditOpenAddressPincode && (
        <TicketEditPincodePopup
          open={state.isEditOpenAddressPincode}
          isPincodeUpdating={state.isPincodeUpdating}
          handleUpdatePincode={handleUpdatePincode}
          handleClose={handleCloseEditPincodePopup}
          isEditOpenTicketDetails={state.isEditOpenTicketDetails}
        />
      )}

      {state.isDeleteAlertPopupOpen && (
        <DeleteAlertDialogModal
          openAlert={state.isDeleteAlertPopupOpen}
          handleAlertClose={handleDeleteCloseModal}
          handleDeleteTicket={handleDeleteRows}
          Heading={state.deleteHeading}
        />
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={state.isLoading}
        onClick={stopLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Grid container>
        <Grid item style={stylesCss.paddingInnerGrids} md={6}>
          <BasicDateRangePicker
            onClickFilter={onClickFilter}
            refreshData={refreshData}
          />
        </Grid>
      </Grid>

      {state.isAssignTechnicianPopupOpen && (
        <AssignTechnicianPopup
          open={state.isAssignTechnicianPopupOpen}
          handleClose={handleCloseAssignTechnicianPopup}
          technicianList={state.technicianList}
          isForChange={state.isForChange}
          handleAssignTechnician={handleAssignTechnician}
          handleChangeTechnician={handleChangeTechnician}
          isTechnicianAssigning={state.isTechnicianAssigning}
          centerlist={state.centerlist}
        />
      )}

      <MUIDataTable
        title={"Pending Requests"}
        data={state.ticketsList}
        columns={columns}
        options={{
          ...options,
          selectableRows: hasDeleteAccess ? "multiple" : "none",
          onRowSelectionChange: hasDeleteAccess
            ? (currentRowsSelected, allRowsSelected) => {
                const selectedIds = allRowsSelected.map(
                  (row) => state.ticketsList[row.dataIndex].ticket_id
                );
                updateState({ selectedTicketIds: selectedIds }, () => {
                  updateSelectedRowsClosingPrice();
                });
              }
            : undefined,
        }}
      />

      {state.doesFileUploadErrorExists && (
        <FileUploadErrors
          doesFileUploadErrorExists={state.doesFileUploadErrorExists}
          errorsList={state.errorsList}
          handleCloseFileUploadErrors={handleCloseFileUploadErrors}
        />
      )}

      <RemarksPopup
        open={state.isRemarksPopupOpen}
        handleClose={handleCloseRemarksPopup}
        onSaveRemarks={handleSaveRemarks}
        selectedTicketId={state.selectedTicketId}
        username={state.username}
        initialRemarks={state.initialRemarks}
        processedname={state.processedname}
      />

      {state.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={state.isConfirmationModalOpen}
          handleClose={handleCloseConfirmationModal}
          handleConfirm={handleBroadcastConfirm}
          message="Are you sure you want to broadcast this ticket?"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  reduxState: state.userReducer,
});

export default connect(mapStateToProps)(PendingTickets);
